import StackKit from "@/shared/components/kit/stack";
import BoxLayoutContent from "@/shared/components/layout/boxLauotContent";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import Content from "./content";
import { Grid } from "@mui/material";
import MapView, { Location } from "@/shared/components/common/map";
import { useQuery } from "@tanstack/react-query";
import { fetchMapgishe } from "@/api/user/home";
import ContentSkeleton from "../walletReports/content.skeleton";
/**
 * Locations
 *
 * نمایش لیست مراکز 20کارت همراه با نقشه موقعیت‌ها.
 *
 * - دریافت داده‌های مراکز از API با استفاده از react-query و `fetchMapgishe`.
 * - تبدیل داده‌ها به نقاط نقشه با ساختار `{ name, lat, lng }`.
 * - نمایش بخش هدر شامل آیکون و عنوان "لیست مراکز 20کارت".
 * - استفاده از کامپوننت `Content` برای نمایش جدول مراکز.
 * - نمایش نقشه با استفاده از `MapView` و نقاط فیلتر شده.
 *
 * @returns JSX.Element
 */

const Locations = () => {
  const { data: dataLocation, isLoading } = useQuery({
    queryKey: ["dataLocation-list-dataPayment"],
    queryFn: fetchMapgishe,
  });

  let points: Location[] = [];
  if (dataLocation && Array.isArray(dataLocation)) {
    points = dataLocation
      .filter(
        (item) =>
          item.latitude &&
          item.longitude &&
          !isNaN(Number(item.latitude)) &&
          !isNaN(Number(item.longitude)),
      )
      .map((item) => ({
        name: `${item.address}`,
        lat: Number(item.latitude),
        lng: Number(item.longitude),
      }));
  }

  return (
    <StackKit>
      <BoxLayoutContent
        sxStyle={{ background: "#fff !important" }}
        titleElement={
          <StackKit direction={"row"}>
            <TypoGraphyKit variant="h6">
              <LocationOnOutlinedIcon />
            </TypoGraphyKit>
            <TypoGraphyKit variant="h6"> لیست مراکز ساعی پی</TypoGraphyKit>
          </StackKit>
        }
      >
        {isLoading ? (
          <ContentSkeleton />
        ) : (
          <Content dataLocation={dataLocation} />
        )}
      </BoxLayoutContent>
      <Grid container spacing={2}>
        <Grid
          size={12}
          sx={{ width: "100%", borderRadius: "10px", overflow: "hidden" }}
        >
          <MapView locations={points} />
        </Grid>
      </Grid>
    </StackKit>
  );
};

export default Locations;
